import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import useDeviceDetect from './DeviceDetector';
import { useLocation } from "react-router";

const ProtectedRoute = ({ element }) => {
  const { isLoggedIn } = useAuth();
  const isMobile = useDeviceDetect();
  const location = useLocation();
  
  if(isMobile && location?.pathname?.includes("/view")) {
    return <Navigate to="/deeplinking" />;
  } else {
    if (!isLoggedIn) {
      return <Navigate to="/" />;
    }
  }

  return element;
};

export default ProtectedRoute;